import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class ClientAuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('clientToken') && localStorage.getItem('clientToken') !== 'null') {
            // logged in so return true
            return true;
        }

        if (sessionStorage.getItem('clientToken') && sessionStorage.getItem('clientToken') !== 'null') {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/client/auth/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}
